<template>
  <div>
    <v-table :height="550" @on-custom-comp="customCompFunc" is-horizontal-resize="" column-width-drag
             style="width:100%;"
             :columns="columns1" :table-data="serverSearchsDate" row-hover-color="#edf7ff"
             :is-loading="modal_loading" title-bg-color="#f8f8f9"></v-table>
    <br/>
    <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage"
          @on-page-size-change="changeSize" :transfer="true"></Page>
    <!-- 删除账户模式框 -->
    <Modal v-model="accountsDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#ff6600;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t('alarms.common.sureDelete') }}{{ $t('schedule_instance_config.thisScheduledTask') }}{{ $t('alarms.common.what') }}?</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long :loading="loading" @click="removeServerSearchs()" :disabled="isDisable">
          {{$t('schedule_instance_config.del')}}
        </Button>
      </div>
    </Modal>
    <!-- 编辑定时任务 -->
    <Modal v-model="editTimeTaskModal" :title="$t('schedule_instance_config.editSystemTask')"
           @on-ok="editTimeTaskSubmit('editTimeTaskForm')" @on-cancel="editTimeTaskReset('editTimeTaskForm')"
           :loading="loadingEdit" :mask-closable="false" width="700px;" :okText="$t('alarms.common.add')"
           :cancelText="$t('alarms.common.cancel')" :styles="{top:'35px'}">
      <Form ref="editTimeTaskForm" :model="editTimeTaskForm" :label-width="100" :rules="ruleException">
        <!-- 状态 -->
        <input type="hidden" v-model="status">

        <Row>
          <Col span="11">
            <!-- 是否例外 -->
            <FormItem :label="$t('schedule_instance_config.isException')" prop="exception">
              <RadioGroup v-model="editTimeTaskForm.exception"
                          @on-change="exceptionTypeChange(editTimeTaskForm.exception)">
                <Radio label="true">{{$t('schedule_instance_config.yes')}}</Radio>
                <Radio label="false">{{$t('schedule_instance_config.no')}}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="11">
            <!-- 是否工作日 -->
            <FormItem :label="$t('schedule_instance_config.isWorkDay')" prop="isWorkDay">
              <RadioGroup v-model="editTimeTaskForm.isWorkDay">
                <Radio v-for="list in workDayEditList" :label="list.isWorkDay" :key="list.value">{{list.label}}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="11">
            <!-- 执行类型 -->
            <FormItem :label="$t('schedule_instance_config.performType')" prop="performType">
              <Select v-model="editTimeTaskForm.performType" style="width:200px;" placeholder=""
                      @on-change="changePerformType">
                <Option :value="item.id" v-for="(item,index) in performTypeList" v-bind:key="index">{{item.name}}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <div v-if="editTimeTaskForm.performType==0">
            <Col span="11">
              <!-- 开机时间 -->
              <FormItem :label="$t('schedule_instance_config.scheduleOpenInstanceTime')" prop="scheduleStartTime">
                <TimePicker v-model="editTimeTaskForm.scheduleStartTime"
                            :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                            style="width: 200px"></TimePicker>
              </FormItem>
            </Col>
            <Col span="11">
              <!-- 关机时间 -->
              <FormItem :label="$t('schedule_instance_config.scheduleCloseInstanceTime')" prop="scheduleEndTime">
                <TimePicker v-model="editTimeTaskForm.scheduleEndTime"
                            :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                            style="width: 200px"></TimePicker>
              </FormItem>
            </Col>
          </div>
          <div v-else-if="editTimeTaskForm.performType==1">
            <Col span="11">
              <!-- 开机时间 -->
              <FormItem :label="$t('schedule_instance_config.scheduleOpenInstanceTime')" prop="scheduleStartTime">
                <TimePicker v-model="editTimeTaskForm.scheduleStartTime"
                            :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                            style="width: 200px"></TimePicker>
              </FormItem>
            </Col>
            <Col span="11">
              <!-- 关机时间 -->
              <FormItem :label="$t('schedule_instance_config.scheduleCloseInstanceTime')" prop="scheduleEndTime">
                <TimePicker v-model="editTimeTaskForm.scheduleEndTime" disabled
                            :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                            style="width: 200px"></TimePicker>
              </FormItem>
            </Col>
          </div>
          <div v-else-if="editTimeTaskForm.performType==2">
            <!-- 当执行关机时 -->
            <Col span="11">
              <!-- 开机时间 -->
              <FormItem :label="$t('schedule_instance_config.scheduleOpenInstanceTime')" prop="scheduleStartTime">
                <TimePicker v-model="editTimeTaskForm.scheduleStartTime" disabled
                            :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                            style="width: 200px"></TimePicker>
              </FormItem>
            </Col>
            <Col span="11">
              <!-- 关机时间 -->
              <FormItem :label="$t('schedule_instance_config.scheduleCloseInstanceTime')" prop="scheduleEndTime">
                <TimePicker v-model="editTimeTaskForm.scheduleEndTime"
                            :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                            style="width: 200px"></TimePicker>
              </FormItem>
            </Col>
          </div>
        </Row>
        <div v-if="isExceptions">
          <Row>
            <Col span="11">
              <!-- 例外开始日期 -->
              <FormItem :label="$t('schedule_instance_config.exceptionStartDate')" prop="exceptionStartDate">
                <DatePicker type="datetime" style="width: 200px" v-model="editTimeTaskForm.exceptionStartDate"
                            :options="editStartTimeOptions"></DatePicker>
              </FormItem>
            </Col>
            <Col span="11">
              <!-- 例外结束日期 -->
              <FormItem :label="$t('schedule_instance_config.exceptionEndDate')" prop="exceptionEndDate">
                <DatePicker type="datetime" style="width: 200px" v-model="editTimeTaskForm.exceptionEndDate"
                            :options="editEndTimeOptions"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <div v-if="editTimeTaskForm.performType==0">
              <Col span="11">
                <!-- 例外开机时间 -->
                <FormItem :label="$t('schedule_instance_config.exceptionStartTime')" prop="exceptionStartTime">
                  <TimePicker v-model="editTimeTaskForm.exceptionStartTime"
                              :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                              style="width: 200px"></TimePicker>
                </FormItem>
              </Col>
              <Col span="11">
                <!-- 例外关机时间 -->
                <FormItem :label="$t('schedule_instance_config.exceptionEndTime')" prop="exceptionEndTime">
                  <TimePicker v-model="editTimeTaskForm.exceptionEndTime"
                              :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                              style="width: 200px"></TimePicker>
                </FormItem>
              </Col>
            </div>
            <div v-else-if="editTimeTaskForm.performType==1">
              <Col span="11">
                <!-- 例外开机时间 -->
                <FormItem :label="$t('schedule_instance_config.exceptionStartTime')" prop="exceptionStartTime">
                  <TimePicker v-model="editTimeTaskForm.exceptionStartTime"
                              :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                              style="width: 200px"></TimePicker>
                </FormItem>
              </Col>
              <Col span="11">
                <!-- 例外关机时间 -->
                <FormItem :label="$t('schedule_instance_config.exceptionEndTime')" prop="exceptionEndTime">
                  <TimePicker v-model="editTimeTaskForm.exceptionEndTime" disabled
                              :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                              style="width: 200px"></TimePicker>
                </FormItem>
              </Col>
            </div>
            <div v-else-if="editTimeTaskForm.performType==2">
              <!-- 当执行关机时 -->
              <Col span="11">
                <!-- 例外开机时间 -->
                <FormItem :label="$t('schedule_instance_config.exceptionStartTime')" prop="exceptionStartTime">
                  <TimePicker v-model="editTimeTaskForm.exceptionStartTime" disabled
                              :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                              style="width: 200px"></TimePicker>
                </FormItem>
              </Col>
              <Col span="11">
                <!-- 例外关机时间 -->
                <FormItem :label="$t('schedule_instance_config.exceptionEndTime')" prop="exceptionEndTime">
                  <TimePicker v-model="editTimeTaskForm.exceptionEndTime"
                              :disabled-seconds="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]"
                              style="width: 200px"></TimePicker>
                </FormItem>
              </Col>
            </div>
          </Row>
        </div>
        <!-- 实例 -->
        <FormItem :label="$t('schedule_instance_config.instance')" prop="instance">
          <Table :no-data-text="$t('common.noData')" :columns="columnInstance" :data="InstancesEditData" :height="200"
                 style="width:510px;"></Table>
        </FormItem>
        <!-- 描述 -->
        <FormItem :label="$t('schedule_instance_config.reason')" prop="describe">
          <Input v-model="editTimeTaskForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                 placeholder="Enter something..." style="width:510px;"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!--查看日志-->
    <Modal v-model="logViewModal" :title="$t('schedule_instance_config.viewLog')" :mask-closable="false" width="700px;" :styles="{top:'35px'}">
      <v-table :height="550" is-horizontal-resize="" column-width-drag style="width:100%;height:550px;"
               :columns="columns3" :table-data="timeSwitchLog" row-hover-color="#edf7ff" :is-loading="modal_loading"
               title-bg-color="#f8f8f9"></v-table>
    </Modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import utils from '../../../utils/utils.js'

  var tableServerTaskSearchs = {}
  export default {
    name: 'TableServerTaskSearchs',
    data() {
      const validatePassStart = (rule, value, callback) => {
        if (this.editTimeTaskForm.performType == 0 || this.editTimeTaskForm.performType == 1) {
          if (this.editTimeTaskForm.scheduleStartTime == '' || this.editTimeTaskForm.scheduleStartTime == undefined) {
            callback(new Error(this.$t('schedule_instance_config.openRequired')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
      const validatePassEnd = (rule, value, callback) => {
        if (this.editTimeTaskForm.performType == 0 || this.editTimeTaskForm.performType == 2) {
          if (this.editTimeTaskForm.scheduleEndTime == '' || this.editTimeTaskForm.scheduleEndTime == undefined) {
            callback(new Error(this.$t('schedule_instance_config.closeRequired')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
      const validatePassExceptionStart = (rule, value, callback) => {
        if (this.editTimeTaskForm.performType == 0 || this.editTimeTaskForm.performType == 1) {
          if (this.editTimeTaskForm.exceptionStartTime == '' || this.editTimeTaskForm.exceptionStartTime == undefined) {
            callback(new Error(this.$t('schedule_instance_config.exceptionOpenRequired')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
      const validatePassExceptionEnd = (rule, value, callback) => {
        if (this.editTimeTaskForm.performType == 0 || this.editTimeTaskForm.performType == 2) {
          if (this.editTimeTaskForm.exceptionEndTime == '' || this.editTimeTaskForm.exceptionEndTime == undefined) {
            callback(new Error(this.$t('schedule_instance_config.exceptionCloseRequired')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
      return {
        performTypeList: [],
        val: '',
        status: '',
        current: 1,
        dataTotal: 0,
        pageSize: 10,
        editTimeTaskModal: false,
        logViewModal: false,
        loadingEdit: true,
        isExceptions: false,
        isFinished: true,
        editTimeTaskForm: {
          performType: '',
          scheduleStartTime: '',
          scheduleEndTime: '',
          exceptionStartTime: '',
          exceptionEndTime: '',
          exceptionStartDate: '',
          exceptionEndDate: '',
          exception: '',
          describe: '',
          isWorkDay: ''
        },
        workDayEditList: [{
          label: this.$t('schedule_instance_config.workDay'),
          value: 'true',
          isWorkDay: 'true'
        }, {
          label: this.$t('schedule_instance_config.everyDay'),
          value: 'false',
          isWorkDay: 'false'
        }],
        exceptionList: [{   //添加定时任务
          label: this.$t('schedule_instance_config.yes'),
          value: 'true',
          exception: 'true'
        }, {
          label: this.$t('schedule_instance_config.no'),
          value: 'false',
          exception: 'false'
        }],
        workDayList: [{
          label: this.$t('schedule_instance_config.workDay'),
          value: 'true',
          isWorkDay: 'true'
        }, {
          label: this.$t('schedule_instance_config.everyDay'),
          value: 'false',
          isWorkDay: 'false'
        }],
        statusLists: [{
          id: 1,
          name: this.$t('schedule_instance_config.start'),
          state: '0'
        }],
        approvalFlowList: [],
        startTimeOptions: {}, //开始日期设置
        endTimeOptions: {}, //结束日期设置
        addTimerSwitchModal: false,
        addLoading: true,
        privateIp: '',
        awsResourceType: '',
        companyId: '',
        reachBottomParam: '',
        exportDataList: '',
        accountsDelmodal: false,
        modal_loading: false,
        loading: false,
        isDisable: false,
        statusList: ["pending", "running", "stopping", "stopped", "shutting down", "terminated"],
        ruleException: {
          scheduleStartTime: [
            {required: false, message: this.$t('schedule_instance_config.selectOpenTime'), trigger: 'change', type: 'string'},
            {validator: validatePassStart, trigger: 'blur'}
          ],
          scheduleEndTime: [
            {required: false, message: this.$t('schedule_instance_config.selectCloseTime'), trigger: 'change', type: 'string'},
            {validator: validatePassEnd, trigger: 'blur'}
          ],
          exceptionStartTime: [
            {required: false, message: this.$t('schedule_instance_config.selectExceptionOpenTime'), trigger: 'change', type: 'string'},
            {validator: validatePassExceptionStart, trigger: 'blur'}
          ],
          exceptionEndTime: [
            {required: false, message: this.$t('schedule_instance_config.selectExceptionCloseTime'), trigger: 'change', type: 'string'},
            {validator: validatePassExceptionEnd, trigger: 'blur'}
          ],
          exceptionStartDate: [
            {required: true, message: this.$t('schedule_instance_config.selectExceptionStartDate'), trigger: 'change', type: 'date'}
          ],
          exceptionEndDate: [
            {required: true, message: this.$t('schedule_instance_config.selectExceptionEndDate'), trigger: 'change', type: 'date'}
          ],
          exception: [
            {required: true, message: this.$t('schedule_instance_config.selectIsException'), trigger: 'change'},
          ],
          isWorkDay: [
            {required: true, message: this.$t('schedule_instance_config.selectIsWorkDay'), trigger: 'change'},
          ],
          describe: [
            {required: true, message: this.$t('schedule_instance_config.inputReason'), trigger: 'blur'},
            {type: 'string', max: 100, message: this.$t('schedule_instance_config.maxChars100'), trigger: 'blur'}
          ]
        },

        columnInstance: [
          {
            title: this.$t('schedule_instance_config.ip'),
            key: 'privateIp'
          },
          {
            title: this.$t('schedule_instance_config.instanceName'),
            key: 'name'
          }],
        columns1: [
          {
            field: 'privateIp',
            title: 'IP',
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'name',
            title: this.$t('schedule_instance_config.instanceName'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'awsResourceType',
            title: this.$t('schedule_instance_config.AWSType'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'instanceStatus',
            title: this.$t('schedule_instance_config.instanceStatus'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'isWorkDay',
            title: this.$t('schedule_instance_config.isWorkDay'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'scheduleStartTime',
            title: this.$t('schedule_instance_config.scheduleOpenInstanceTime'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'scheduleEndTime',
            title: this.$t('schedule_instance_config.scheduleCloseInstanceTime'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'isException',
            title: this.$t('schedule_instance_config.isException'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'exceptionStartDate',
            title: this.$t('schedule_instance_config.exceptionStartDate'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'exceptionEndDate',
            title: this.$t('schedule_instance_config.exceptionEndDate'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'exceptionStartTime',
            title: this.$t('schedule_instance_config.exceptionStartTime'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'exceptionEndTime',
            title: this.$t('schedule_instance_config.exceptionEndTime'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'status',
            title: this.$t('alarms.common.status'),
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true
          },
          {
            field: 'action',
            title: this.$t('common.operation'),
            width: 180,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            componentName: 'button-task'
          }
        ],
        columns3: [
          {
            field: 'action',
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            title: this.$t('common.operation')
          },
          {
            field: 'status',
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            title: this.$t('schedule_instance_config.status')
          },
          {
            field: 'createdTime',
            width: 80,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            title: this.$t('schedule_instance_config.time')
          }],
        columns4: [
          {
            title: this.$t('schedule_instance_config.ip'),
            key: 'privateIp'
          },
          {
            title: this.$t('schedule_instance_config.instanceName'),
            key: 'name'
          },
          {
            title: this.$t('schedule_instance_config.instanceStatus'),
            key: 'state'
          }],
        startTimeOptions: {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
        endTimeOptions: {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
        editStartTimeOptions: {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
        editEndTimeOptions: {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
        serverSearchsDate: [],
        timeSwitchLog: [],
        InstancesData: [],
        insertIPList: [],
        InstancesEditData: [],
        insertIPLists: []
      }
    },
    beforeCreate: function () {
      tableServerTaskSearchs = this
    },
    methods: {
      // 审批流
      selectListNames: function () {
        this.$api.processTemplate.selectListNames({
          "type": 2
        })
          .then(res => {
            this.approvalFlowList = res.data;
          })
      },
      //查询执行类型
      queryPerformType: function () {
        this.$api.schedule.queryPerformType()
          .then(res => {
            this.performTypeList = res.data;
          })
      },
      //切换类型
      changePerformType: function () {
        if (this.editTimeTaskForm.performType == 2 && this.editTimeTaskForm.exception == 'true') {
          if (this.editTimeTaskForm.exceptionStartTime == '' || this.editTimeTaskForm.exceptionStartTime == undefined) {
            this.editTimeTaskForm.exceptionStartTime = '00:00:00';
          }
        }
        if (this.editTimeTaskForm.performType == 1 && this.editTimeTaskForm.exception == 'true') {
          if (this.editTimeTaskForm.exceptionEndTime == '' || this.editTimeTaskForm.exceptionEndTime == undefined) {
            this.editTimeTaskForm.exceptionEndTime = '00:00:00';
          }
        }
        if (this.editTimeTaskForm.performType == 1) {
          if (this.editTimeTaskForm.scheduleEndTime == '' || this.editTimeTaskForm.scheduleEndTime == undefined) {
            this.editTimeTaskForm.scheduleEndTime = '00:00:00';
          }
        }
        if (this.editTimeTaskForm.performType == 2) {
          if (this.editTimeTaskForm.scheduleStartTime == '' || this.editTimeTaskForm.scheduleStartTime == undefined) {
            this.editTimeTaskForm.scheduleStartTime = '00:00:00';
          }
        }
      },
      // 显示数据
      /**************************************************************/
      showAll: function (privateIp, single, awsResourceType, companyId) {
        tableServerTaskSearchs.val = single;
        tableServerTaskSearchs.privateIp = privateIp;
        tableServerTaskSearchs.awsResourceType = awsResourceType;
        tableServerTaskSearchs.companyId = companyId;
        tableServerTaskSearchs.getServerSearchsData();
      },
      showTableServerSearchs: function () {
        for (var i = 0; i < this.serverSearchsDate.length; i++) {
          if (this.serverSearchsDate[i].scheduleStartTime === undefined || this.serverSearchsDate[i].scheduleStartTime == null || this.serverSearchsDate[i].scheduleEndTime == undefined || this.serverSearchsDate[i].scheduleEndTime == null) {
            this.serverSearchsDate[i].scheduleStartTime = '---';
            this.serverSearchsDate[i].scheduleEndTime = '---';
          }
          // 是否例外
          if (this.serverSearchsDate[i].isException == true) {
            this.serverSearchsDate[i].isException = this.$t('common.yes');
            // 例外开始时间
            this.serverSearchsDate[i].exceptionStartDate = utils.methods.formatDate(this.serverSearchsDate[i].exceptionStartDate);
            // 例外结束时间
            this.serverSearchsDate[i].exceptionEndDate = utils.methods.formatDate(this.serverSearchsDate[i].exceptionEndDate);
          } else if (this.serverSearchsDate[i].isException == false) {
            this.serverSearchsDate[i].isException = this.$t('common.no');
            // 不是例外 那么例外开始、结束、开机、关机都为---
            this.serverSearchsDate[i].exceptionStartDate = '---';
            this.serverSearchsDate[i].exceptionEndDate = '---';
            this.serverSearchsDate[i].exceptionStartTime = '---';
            this.serverSearchsDate[i].exceptionEndTime = '---';
          }

          //是否工作日
          if (this.serverSearchsDate[i].isWorkdays) {
            this.serverSearchsDate[i].isWorkDay = this.$t('common.yes');
          } else {
            this.serverSearchsDate[i].isWorkDay = this.$t('common.no');
          }

          // 状态
          if (this.serverSearchsDate[i].status == 0) {
            this.serverSearchsDate[i].status = this.$t('schedule_instance_config.start');
          } else if (this.serverSearchsDate[i].status == 1) {
            this.serverSearchsDate[i].status = this.$t('schedule_instance_config.pause');
          } else if (this.serverSearchsDate[i].status == 2) {
            this.serverSearchsDate[i].status = this.$t('schedule_instance_config.close');
          } else if (this.serverSearchsDate[i].status == 3) {
            this.serverSearchsDate[i].status = this.$t('schedule_instance_config.exception');
          }

          // aws资源类型
          if (this.serverSearchsDate[i].awsResourceType == 0) {
            this.serverSearchsDate[i].awsResourceType = this.$t('schedule_instance_config.virtualHost');
          } else if (this.serverSearchsDate[i].awsResourceType == 7) {
            this.serverSearchsDate[i].awsResourceType = this.$t('schedule_instance_config.virtualDesktop');
          }
        }
      },
      // 根据私有IP查询实例和定时任务
      getServerSearchsData: function () {
        this.modal_loading = true;
        // 根据私有IP查询实例和定时任务
        tableServerTaskSearchs.$api.instance.queryTimedTaskByPrivateIP({
          "pageNum": 1,
          "hasTask": tableServerTaskSearchs.val,
          "maxResult": 15,
          "privateIp": tableServerTaskSearchs.privateIp,
          "companyId": tableServerTaskSearchs.companyId,
          "awsResourceType": tableServerTaskSearchs.awsResourceType
        })
          .then(res => {
            this.reachBottomParam = res.data;
            if (res.data.records) {
              this.exportDataList = JSON.parse(JSON.stringify(res.data));
              this.serverSearchsDate = JSON.parse(JSON.stringify(res.data.records));
            }
            tableServerTaskSearchs.showTableServerSearchs();
            this.modal_loading = false;
            // 当前页
            this.current = res.data.current;
            // 总条数
            this.dataTotal = res.data.total;
          })
      },
      // 删除 编辑 日志
      /**************************************************************/
      // 传递vue组件
      customCompFunc(params) {
        if (params.type === 'delete') {
          this.lineIndex = params.index;
          this.accountsDelmodal = true;
        } else if (params.type === 'edit') {
          this.rowClick(params.index, params.rowData);
        } else if (params.type === 'log') {
          this.logViewClick(params.rowData);
        }

      },
      changePage: function (current) {
        this.current = current;
        tableServerTaskSearchs.getServerSearchsData()
      },
      changeSize: function (pageSize) {
        this.pageSize = pageSize;
        tableServerTaskSearchs.getServerSearchsData()
      },
      removeServerSearchs: function () {
        this.isDisable = true;  //开始可以点击
        var lineIndex = this.lineIndex;
        //删除
        tableServerTaskSearchs.$api.schedule.deleteSchedule("id", this.serverSearchsDate[lineIndex].id)
          .then(res => {
            this.loading = true;
            setTimeout(() => {
              tableServerTaskSearchs.getServerSearchsData();
              this.isDisable = false;
              this.loading = false;
              this.accountsDelmodal = false;
              this.$Message.success(this.$t('common.deleteSuccess'));
            }, 1000);
          })
      },

      getState: function (stateStr) {
        for (var i = 0; i < this.statusList.length; i++) {
          if (stateStr == this.statusList[i]) {
            return i;
          }
        }
        return -1;
      },
      rowClick(rowIndex, rowData) {
        this.insertIPList = [];
        this.insertIPLists = [];
        this.selectListNames();
        this.queryPerformType();
        //编辑定时任务
        this.editTimeTaskModal = true;

        //编辑定时任务
        this.$api.schedule.editSchedule("id", rowData.id)
          .then(res => {
            this.editTimeTaskModal = true;
            //id
            this.id = res.data.id;
            //状态
            this.status = res.data.status;
            //执行类型
            this.editTimeTaskForm.performType = res.data.performType;
            //是否例外
            /*********如果不是例外*************/
            if (res.data.isException == false) {
              this.editTimeTaskForm.exception = 'false';
              this.isExceptions = false;

            }
            /*********如果是例外***********/
            else if (res.data.isException == true) {
              this.editTimeTaskForm.exception = 'true';
              this.isExceptions = true;
              //例外开机时间
              this.editTimeTaskForm.exceptionStartTime = res.data.exceptionStartTime;
              //例外关机时间
              this.editTimeTaskForm.exceptionEndTime = res.data.exceptionEndTime;
              //例外开始日期
              this.editTimeTaskForm.exceptionStartDate = utils.methods.formatDate(res.data.exceptionStartDate);
              //例外结束日期
              this.editTimeTaskForm.exceptionEndDate = utils.methods.formatDate(res.data.exceptionEndDate);
            }
            //是否工作日 工作日
            if (res.data.isWorkdays == true) {
              this.editTimeTaskForm.isWorkDay = 'true';
            }
            // 每天
            else if (res.data.isWorkdays == false) {
              this.editTimeTaskForm.isWorkDay = 'false';
            }

            //开机时间
            this.editTimeTaskForm.scheduleStartTime = res.data.scheduleStartTime;
            //关机时间
            this.editTimeTaskForm.scheduleEndTime = res.data.scheduleEndTime;
            //实例
            this.InstancesEditData = res.data.instanceDTOS;
            //申请原因
            this.editTimeTaskForm.describe = res.data.description;
          })
      },
      //日志查看
      logViewClick(rowData) {
        var logViewData = {
          "scheduleId": rowData.id,
          "resourceId": rowData.instanceId,
          "pageNum": this.current,
          "pageSize": this.pageSize
        };
        //查看日志
        this.$api.schedule.logView(logViewData)
          .then(res => {
            this.logViewModal = true;
            this.timeSwitchLog = res.data;
          })
      },
      // 编辑定时任务
      /*************************************************************************/
      exceptionTypeChange: function () {
        if (this.editTimeTaskForm.exception == 'true') {
          this.isExceptions = true;
        } else if (this.editTimeTaskForm.exception == 'false') {
          this.isExceptions = false;
        }
      },
      editTimeTaskSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            var updateData = {
              "id": this.id,
              "status": this.status,
              "performType": this.editTimeTaskForm.performType,
              "isException": this.editTimeTaskForm.exception,
              "isWorkdays": this.editTimeTaskForm.isWorkDay,
              "description": this.editTimeTaskForm.describe,
              "instanceDTOS": this.InstancesEditData,
              "scheduleStartTime": this.editTimeTaskForm.scheduleStartTime,
              "scheduleEndTime": this.editTimeTaskForm.scheduleEndTime,
            };
            if (this.editTimeTaskForm.exception == 'true') {
              updateData.exceptionStartTime = this.editTimeTaskForm.exceptionStartTime;
              updateData.exceptionEndTime = this.editTimeTaskForm.exceptionEndTime;
              updateData.exceptionStartDate = this.editTimeTaskForm.exceptionStartDate;
              updateData.exceptionEndDate = this.editTimeTaskForm.exceptionEndDate;
            }
            // 编辑定时任务
            this.$api.schedule.updateSchedule(updateData)
              .then(res => {
                setTimeout(() => {
                  this.$refs[name].resetFields();
                  this.loadingEdit = false;
                  this.$nextTick(() => {
                    this.loadingEdit = true;
                  });
                  this.$Message.success(this.$t('common.editSuccess'));
                  tableServerTaskSearchs.getServerSearchsData();
                  this.editTimeTaskModal = false;
                }, 1000);
              })
          } else {
            //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
            this.loadingEdit = false;
            setTimeout(() => {
              this.loadingEdit = true
            }, 0)
            this.$Message.error(this.$t('common.editFail'));
          }
        });
      },
      editTimeTaskReset: function (name) {
        this.$refs[name].resetFields();
      }
    }
  }
  // 自定义列删除组件  如果当前行有id显示删除按钮
  Vue.component('button-task', {
    template: `<span>
      <Button id="edit" @click.stop.prevent="logView(rowData,index)"
                    style="color: #fff;background-color: #2db7f5;border-color: #2db7f5;cursor: pointer;padding: 1px 7px 2px;font-size: 12px;border-radius: 3px;height: 23px;border: none;line-height: 23px;outline: none;"
      >{{$t('schedule_instance_config.log')}}</Button>
      &nbsp;
      <Button id="edit" @click.stop.prevent="editRow(rowData,index)"
              style="color: #fff;background-color: #2db7f5;border-color: #2db7f5;cursor: pointer;padding: 1px 7px 2px;font-size: 12px;border-radius: 3px;height: 23px;border: none;line-height: 23px;outline: none;"
      >{{$t('common.edit')}}</Button>
      &nbsp;
      <Button id="delete" @click.stop.prevent="deleteRow(rowData,index)"
              style="color: #fff;background-color: #ed4014;border-color: #ed4014;padding: 1px 7px 2px;font-size: 12px;border-radius: 3px;height: 23px;border: none;line-height: 23px;outline: none;"
      >{{$t('common.del')}}</Button></span>`,
    props: {
      rowData: {
        type: Object
      },
      field: {
        type: String
      },
      index: {
        type: Number
      }
    },
    methods: {
      deleteRow() {
        // 删除
        let params = {type: 'delete', index: this.index, rowData: this.rowData};
        this.$emit('on-custom-comp', params);
      },
      editRow() {
        // 编辑
        let params = {type: 'edit', index: this.index, rowData: this.rowData};
        this.$emit(`on-custom-comp`, params);
      },
      logView() {
        // 日志
        let params = {type: 'log', index: this.index, rowData: this.rowData};
        this.$emit(`on-custom-comp`, params);
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/timer_switchs/server_searchs/TableServerTaskSearchs.vue